import { SettingsDisabledInput } from './SettingsDisabledInput';
import { SettingsCard } from './SettingsCard';
import {FormItem, PhoneField, SelectField} from 'componets/form';
import { useAppSelector, useTranslate } from 'hooks';
import { Rules } from 'utils/constants';
import s from './index.module.scss';
import {SettingsAddressCard} from "./SettingsAddressCard";
import {useMemo} from "react";
import {Country} from "../../../models";
import {selectCountries} from "../../../selectors";

const WORDS = [
	'firstNameText',
	'lastNameText',
	'personalInformationText',
	'companyInformationText2',
	'downloadText',
	'userAgreementText',
	'emailAddressText',
	'agreementNotFoundText',
	'countryText',
	'citizenshipText'
];
export const SettingsPersonalInformationCard = ({ userType = 'user' }) => {
	const settings = useAppSelector((state) => state.userSettings.entity);
	const t = useTranslate(WORDS);
	const isUser = userType === 'user';
	const countries = useAppSelector(selectCountries);
	const countriesOptions = useMemo(() => {
		const currentCountry =
			countries?.find((item) => +item.id === +settings.citizenship_id) || ({} as Country);
		return countries
			?.filter((item) => item.activeCitizenship || item.id === currentCountry.id)
			.map((item) => {
				return {
					label: item.label,
					value: item.id,
				};
			});
	}, [countries, settings.citizenship_id]);
	return (
		<SettingsCard title={ isUser ? t.personalInformationText : t.companyInformationText2}>
			<div className={s.formGrid}>
				<FormItem name="first_name" className={s.gridItem}>
					<SettingsDisabledInput
						className={s.col}
						name={t.firstNameText}
						value={settings.first_name}
					/>
				</FormItem>
				<FormItem name="last_name" className={s.gridItem}>
					<SettingsDisabledInput
						className={s.col}
						name={t.lastNameText}
						value={settings.last_name}
					/>
				</FormItem>
				<FormItem name="email" className={s.gridItem}>
					<SettingsDisabledInput
						className={s.col}
						name={t.emailAddressText}
						value={settings.email}
					/>
				</FormItem>
				<FormItem
					className={`${s.input} ${s.gridItem}`}
					name="phone"
					rules={[Rules.REQUIRED, Rules.PHONE('phone')]}
				>
					<PhoneField isSettings />
				</FormItem>
				<FormItem
					className={`${s.input} ${s.gridItem}`}
					name="citizenship_id"
					rules={[Rules.REQUIRED_SELECT]}
				>
					{Boolean(settings.citizenship_id) ? (
						<SettingsDisabledInput
							className={s.col}
							name={t.citizenshipText}
							options={countriesOptions}
							value={settings.citizenship_id}
						/>
					) : (
						<SelectField
							disabled={Boolean(settings.citizenship_id)}
							options={countriesOptions}
							placeholder={t.citizenshipText}
							isFilter
						/>
					)}
				</FormItem>
				{isUser && <SettingsAddressCard /> }
			</div>
		</SettingsCard>
	);
};
